var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1075,
    height: 207,
    viewBox: "0 0 1075 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75272 153.951C17.1815 166.018 37.5448 170.955 54.4738 177.342C78.0431 186.233 103.414 190.625 128.662 193.329C153.618 196.001 178.574 198.674 203.529 201.346C217.773 202.871 231.622 202.968 245.908 203.073C256.359 203.15 266.444 201.18 276.62 200.35C287.197 199.487 298.011 198.611 308.195 196.079C319.019 193.388 330.698 193.077 341.435 190.074C355.711 186.081 370.79 183.295 385.288 179.661C401.216 175.668 417.311 171.294 432.24 165.091C448.77 158.221 465.08 148.409 478.352 137.234C492.011 125.734 506.465 115.07 516.599 100.728C532.483 78.2498 543.325 50.2858 533.931 23.4095C531.566 16.6412 527.371 7.9117 519.471 5.22963C513.604 3.23784 506.016 2.37981 500.66 5.32342C491.733 10.2295 487.387 20.7975 486.281 29.8628C485.427 36.8669 483.707 44.5859 484.819 51.6471C486.246 60.712 489.228 69.3994 491.274 78.3394C494.438 92.162 501.513 107.359 513.127 117.3C529.636 131.43 554.173 136.172 575.469 140.685C593.155 144.433 611.642 146.667 629.632 148.593C646.901 150.443 664.318 153.049 681.667 153.619C689.176 153.866 696.605 154.292 704.116 154.501C716.12 154.833 728.22 154.32 740.189 154.967C763.226 156.211 784.341 151.321 806.717 148.193C836.759 143.993 866.565 138.875 895.276 129.957C903.328 127.456 911.101 124.362 919.058 121.651C927.484 118.779 936.512 117.015 944.751 113.783C955.476 109.576 965.704 103.165 975.136 97.048C983.943 91.3366 993.235 86.4257 1001.74 80.2982C1007.73 75.9791 1012.55 70.2633 1019.13 66.6226C1029.37 60.9562 1036.47 51.6993 1045.73 45.0313C1052.89 39.871 1058.45 33.0117 1064.56 26.8253C1066.19 25.1752 1070.78 21.6359 1071.01 19.4731",
    stroke: "url(#paint0_linear_318_833)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "20 20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_833",
    x1: 156.772,
    y1: 107.852,
    x2: 1033.63,
    y2: 132.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3C4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrail);
export default __webpack_public_path__ + "static/media/trail.ad8762c36183b0f8f59d742d885c7c1f.svg";
export { ForwardRef as ReactComponent };